import { IDocumentsEditApplicationState } from './interfaces';
import { IEditDocumentAction } from './actions';

export const DocumentEditReducer = (
  oldState: IDocumentsEditApplicationState,
  action: IEditDocumentAction
): IDocumentsEditApplicationState => {
  switch (action.type) {
    case 'SetEditResetModal':
      return { ...oldState, showModal: false, isLoading: true, document: undefined };
    case 'SetEditShowModal':
      return { ...oldState, showModal: true };
    case 'SetEditIsLoading':
      return { ...oldState, isLoading: action.payload };
    case 'SetEditDocument':
      return { ...oldState, document: action.payload };
  }
};
